import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

type Variant = 'default' | 'transparent' | 'white';

@Component({
  selector: 'ui-simple-expand',
  templateUrl: './simple-expand.component.html',
  styleUrls: ['./simple-expand.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleExpandComponent {
  @Input() public variant: Variant = 'default';
  @Input() public isExpanded = false;

  public toggleExpand(event: MouseEvent | Event): void {
    event.preventDefault();

    this.isExpanded = !this.isExpanded;
  }
}
